import { render } from "./FirstTextComponent.vue?vue&type=template&id=b009009e&scoped=true"
import script from "./FirstTextComponent.vue?vue&type=script&lang=js"
export * from "./FirstTextComponent.vue?vue&type=script&lang=js"

import "./FirstTextComponent.vue?vue&type=style&index=0&id=b009009e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b009009e"]])

export default __exports__